import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { PersonnelSearchableSelectorViewModel } from "../personnelManipulation/personnelSelector";
import  { AssignedInternalPhoneNumberManipulationView } from "./assignedInternalPhoneNumberManipulation-view"

export class AssignedInternalPhoneNumberManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'شماره تماس پرسنل ها';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.assignedInternalPhoneNumber = ObservableArray.create<assignedInternalPhoneNumber>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new AssignedInternalPhoneNumberManipulationView();
    }
    public getTypeId(): string {
        return "VM-531BD65E-387A-4C9B-AA40-801184AAA41A"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set assignedInternalPhoneNumber(v: ObservableArray<assignedInternalPhoneNumber>) { this._assignedInternalPhoneNumber = v; } public get assignedInternalPhoneNumber(): ObservableArray<assignedInternalPhoneNumber> { return this._assignedInternalPhoneNumber;} private _assignedInternalPhoneNumber: ObservableArray<assignedInternalPhoneNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllAssignedInternalPhoneNumber',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.assignedInternalPhoneNumber.update(...result.AssignedInternalPhoneNumber.map(q=>{
                let r = new assignedInternalPhoneNumber(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.personnelId = q.PersonnelId;
                r.personnelName = q.PersonnelName;
                r.phoneNumber = q.PhoneNumber;
                r.from = moment.utc(q.From);
                r.until = q.Until==null? null : moment.utc(q.Until);
                r.canInvalidate = q.Until==null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestAssignedInternalPhoneNumberCreation(){
        let editor = new assignedInternalPhoneNumberEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/AssignedInternalPhoneNumberInvalidator',{
                Id:id
            });
            await this.messageBoxConfirmSuccess('شماره تلفن غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}
export class assignedInternalPhoneNumber extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:AssignedInternalPhoneNumberManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set phoneNumber(v: string) { this._phoneNumber = v; } public get phoneNumber(): string { return this._phoneNumber;} private _phoneNumber: string;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate;} private _canInvalidate: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
        
    private _typedParent:AssignedInternalPhoneNumberManipulationViewModel;

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }    

    setPersonnel(id: string, name: string) {
        this.personnelId = id;
        this.personnelName = name;
    }
    getPersonnelId() {
        return this.personnelId;
    }
    
    async inactiveAssignedInternalPhoneNumber():Promise<void>{
        if(this.canInvalidate) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن شماره تلفن');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }

}

interface IServerUpdater{
    execute(assignedInternalPhoneNumber:assignedInternalPhoneNumber):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'صدور شماره تلفن با موفقیت ثبت شد.';
    }
    async execute(assignedInternalPhoneNumber: assignedInternalPhoneNumber): Promise<void> {
        await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateAssignedInternalPhoneNumber',{
            Personnel:assignedInternalPhoneNumber.getPersonnelId(),
            PhoneNumber:assignedInternalPhoneNumber.phoneNumber
        });
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شماره تلفن با موفقیت به روز رسانی شد.';

    }
    async execute(assignedInternalPhoneNumber: assignedInternalPhoneNumber): Promise<void> {
        
    }
}

export class assignedInternalPhoneNumberEditor extends assignedInternalPhoneNumber implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:AssignedInternalPhoneNumberManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.personnelSelector = new PersonnelSearchableSelectorViewModel(this, true, null, false, false, false, false, false);
        this.personnelSelector.onSelectionChanged = q=>{
            this.personnelName = q.title;
            this.personnelId = q.id;
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set personnelSelector(v: PersonnelSearchableSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchableSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchableSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.phoneNumber)){
            result.push(' شماره تماس مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getPersonnelId())){
            result.push(' پرسنل مشخص نشده است.')
        }
        return result;
    }

    setPersonnel(id: string, name: string) {
        this.personnelSelector.selectById(id);
    }

    getPersonnelId() {
        return this.personnelSelector.selectedItem.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت شماره تلفن');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}
